export const colors = {
    background: {
        light: '#F5F5F5',
        pending: '#FFFAEB',
        critical: '#FEF3F2',
        success: '#F0FFEB',
    },
    text: {
        default: '#000000',
        secondary: '#5C5C5C',
        disabled: '#9F9F9F',
        critical: '#D70D31',
        success: '#3B9F17',
        interactive: '#FFFFFF',
        pending: '#E8B021',
    },
    borders: {
        default: '#D5DCE5',
        hover: '#CBD4DF',
        pressed: '#949EAA',
        disabled: '#E6E6E6',
        critical: '#FFBDBD',
        highlight: '#286AF6',
    },
    surface: {
        black: '#000000',
        default: '#FFFFFF',
        interactiveDefault: '#F5F6F7',
        hover: '#F0F1F2',
        pressed: '#F0F1F2',
        disabled: '#EAEBEC',
        popup: '#00000080',
        tertiary: '#F2F5F7',
        rejectedBackground: '#FBE7EA',
        //Note: for making easier changes to gradients everywhere
        gradient: 'linear-gradient(91.56deg, #3D62D7 1.48%, #191C7A 100.57%)',
    },
    interactive: {
        brandColor: '#286AF6',
        brandColorHover: '#1D57D1',
        brandColorPressed: '#1752CF',
        brandColorDisabled: '#CDDCFC',
        secondary: '#EBF1FE',
        secondaryHover: '#EBF1FE',
        secondaryDisabled: '#F5F7FD',
        critical: '#D70D31',
        criticalHover: '#B90929',
        criticalPressed: '#AE0927',
        criticalDisabled: '#FAA9B7',
    },
};
export const darkColors = {
    background: {
        light: '#15191E',
        pending: '#3A362F',
        critical: '#FEF3F2',
        success: '#F0FFEB',
    },
    text: {
        default: '#FFFFFF',
        secondary: '#B9BABC',
        disabled: '#666666',
        critical: '#D70D31',
        success: '#3B9F17',
        pending: '#E8B021',
        interactive: '#FFFFFF',
    },
    borders: {
        default: '#4D5468',
        hover: '#3F4556',
        pressed: '#383C4A',
        disabled: '#313644',
        critical: '#7D1931',
        highlight: '#FFFFFF',
    },
    surface: {
        black: '#000000',
        default: '#222530',
        interactiveDefault: '#15191E',
        hover: '#0C0E11',
        pressed: '#07090B',
        disabled: '#1B1F24',
        popup: '#000000CC',
        tertiary: '#F2F5F7',
        rejectedBackground: '#412C3A',
        //Note: for making easier changes to gradients everywhere
        gradient: 'linear-gradient(92deg, #3D62D7 1.48%, #191C7A 100.57%)',
    },
    interactive: {
        brandColor: '#506BF9',
        brandColorHover: '#3051FF',
        brandColorPressed: '#F2F2F2',
        brandColorDisabled: '#233057',
        critical: '#D70D31',
        criticalHover: '#B90929',
        criticalPressed: '#AE0927',
        criticalDisabled: '#FAA9B7',
        secondary: '#292C36',
        secondaryHover: '#30323D',
        secondaryDisabled: '#30323D',
    },
};
export default colors;
//# sourceMappingURL=colors.js.map